"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _Maker = _interopRequireDefault(require("./Maker"));

var _Currency = require("./eth/Currency");

var _conversion = require("./utils/conversion");

var _QueryApi = require("./QueryApi");

for (var symbol in _Currency.currencies) {
  _Maker["default"][symbol] = _Currency.currencies[symbol];
}

_Maker["default"].currencies = _Currency.currencies;
_Maker["default"].QueryApi = {
  getQueryResponse: _QueryApi.getQueryResponse
};
_Maker["default"].utils = {
  stringToBytes32: _conversion.stringToBytes32
};
module.exports = _Maker["default"];